import React from "react";
import { useFormContext } from "react-hook-form";

import { resolveImage } from "@/helpers";
import { SizeInput } from "@/components/main";

interface Props {
  title: string;
  subtitle: string;
  image: string;
  isSideA: boolean;
  amount: number | "";
  setAmount: (amount: number | string) => void;
}

const BetPlacement: React.FC<Props> = ({
  title,
  subtitle,
  image,
  isSideA,
  amount,
  setAmount,
}) => {
  const { setValue } = useFormContext();

  const handleChange = (newSize: number | string) => {
    const side = isSideA ? 1 : 2;
    const newValue = Number(newSize);
    setAmount(newValue === 0 ? "" : newValue);
    setValue("bet", {
      side: newValue === 0 ? null : side,
      amount: newValue === 0 ? "" : newValue,
    });
  };

  return (
    <div className="flex w-full space-x-6 md:w-auto">
      <img
        className="size-20 flex-shrink-0 rounded-md sm:size-24 md:size-20"
        src={resolveImage(image, "400x400")}
        alt={title}
      />
      <div className="flex w-full flex-col items-start justify-between gap-1 sm:gap-2 md:w-auto">
        <div className="flex flex-col gap-1.5 sm:gap-2">
          <h5 className="font-geist text-lg leading-3 xl:text-lg 2xl:text-[1.25rem]">
            {title}
          </h5>
          <p className="font-geist text-xs text-slate-400">{subtitle}</p>
        </div>
        <SizeInput
          className="h-8"
          placeholder="0.00"
          size={amount}
          setSize={handleChange}
          hideMaxButton
        />
      </div>
    </div>
  );
};

export default BetPlacement;
